import { AbstractControl, ValidatorFn, Validators } from '@angular/forms';

export const ACCOUNT_NAME_MIN = 3;
export const COMPANY_NAME_MIN = 2;
export const SHOP_NAME_MIN = 2;
export const ACCOUNT_NAME_MAX = 100;
export const ACCOUNT_NAME_VALIDATORS: ValidatorFn[] = [
  Validators.required,
  Validators.minLength(ACCOUNT_NAME_MIN),
  Validators.maxLength(ACCOUNT_NAME_MAX),
  forbiddenCharacterValidator('_')
];

function forbiddenCharacterValidator(character: string): ValidatorFn {
  return (control: AbstractControl) => {
    const hasForbiddenCharacter = control.value && control.value.includes(character);
    return hasForbiddenCharacter ? { forbiddenCharacter: true } : null;
  };
}
